
import { mapGetters, mapActions } from 'vuex';
export default {
	components: {
		topbarDefault			: () => import('../topbar/topbar-default.vue'),
		profileImage			: () => import('../account/profile-image.vue'),
		vcDynamicLink			: () => import('../../components/pages/dynamic-link.vue'),
        dynamicComponentLoader  : () => import('../pages/dynamic-component-loader.vue')
	},
	data() {
		
		return {
			isLandingPage		: this.$route.path.indexOf('/landing/') >= 0,
			isBlogPage			: this.$route.path.indexOf('/blog/') >= 0,
			openSidebar			: false,
			fixed_header		: false,
			effect_header		: false,
			show_navbar			: false,
			store_information	: null
		}
	},
	async mounted(){
		
		await this.loginUserEvent();
		this.$root.$on('login-user', this.loginUserEvent);
	},
	computed: {
		...mapGetters({
			getterTranslates: 'getterTranslates',
			getterStoreLang	: 'getterStoreLang',
			getterLogin		: 'getterLogin',
			getterBasicData	: 'getterBasicData',
			getterUser		: 'getterUser',
			getterLevel		: 'getterLevel'
		})
	},
	methods: {
		...mapActions({
			getLevelCustomer: 'getLevelCustomer',
			logoutUser		: 'logoutUser',
		}),
		async loginUserEvent(isLogin){
			
			if( this.getterLogin ){
				
				await this.getLevelCustomer();
			}
		},
		openAccount($event){
			
			this.$root.$emit('show-sidebar-account', true);
		},
		logout() {
			this.logoutUser();
			this.$router.push('/account/login');
		}
	}
}
